module.exports = __webpack_public_path__ + "media/images/icons/fliist_modal_pwa-d9c83b206caa074bba6fd4f95e8275ba.svg";